import { useTranslation } from 'react-i18next';

import { Icon } from './Icon';

import type { IconName } from './Icon';
import type { ReactNode } from 'react';

/** Vacío: qué falta y qué hacer (docs/08 §10). */
export function Empty({
  icon = 'book',
  title,
  hint,
  action,
}: {
  icon?: IconName;
  title: string;
  hint?: string;
  action?: ReactNode;
}) {
  return (
    <div className="empty">
      <Icon name={icon} size={32} />
      <strong>{title}</strong>
      {hint !== undefined && <span className="small">{hint}</span>}
      {action}
    </div>
  );
}

/** Error dentro de la tarjeta afectada, con "Probá de nuevo". */
export function ErrorBanner({ message, onRetry }: { message: string; onRetry?: () => void }) {
  const { t } = useTranslation();
  return (
    <div className="banner p-bad" role="alert">
      <span>{message}</span>
      {onRetry !== undefined && (
        <button type="button" className="btn sm" onClick={onRetry}>
          {t('common.retry')}
        </button>
      )}
    </div>
  );
}

/** Esqueleto con la forma del contenido (nunca un spinner a pantalla completa). */
export function Skeleton({ height = 16, width = '100%' }: { height?: number; width?: number | string }) {
  return <div className="skel" style={{ height, width }} aria-hidden="true" />;
}

export function LoadingClinic() {
  const { t } = useTranslation();
  return (
    <div className="auth-page" aria-busy="true">
      <div className="auth-card">
        <span className="muted">{t('common.loadingClinic')}</span>
        <Skeleton height={40} />
        <Skeleton height={120} />
      </div>
    </div>
  );
}
